const CompositeLog = require('./lib/composite-log');
const DebugLogger = require('./lib/debug-log');
const {externalLoggerFactory, ASPECT_LOGGER_FACTORY} = require('./lib/external-log');

class Logger extends CompositeLog {
  constructor(name) {
    super(new DebugLogger(name), externalLoggerFactory({name}));
  }
}

module.exports = name => new Logger(name);
module.exports.Logger = Logger;
module.exports.ASPECT_LOGGER_FACTORY = ASPECT_LOGGER_FACTORY;
